import React, { useId } from "react";
import { cn } from "../../lib/cn";

/** Cities commonly served from our Temecula shop location. */
export const SERVICE_AREA_CITIES = [
  "Temecula",
  "Murrieta",
  "Menifee",
  "Winchester",
  "French Valley",
  "Lake Elsinore",
];

export default function ServiceAreas({ className, tone = "light" }) {
  const light = tone === "light";
  const headingId = useId();

  return (
    <section
      className={cn("", className)}
      aria-labelledby={headingId}
    >
      <h2
        id={headingId}
        className={cn(
          "text-lg font-semibold tracking-tight sm:text-xl",
          light ? "text-navy-900" : "text-white",
        )}
      >
        Proudly Serving Drivers Across Our Local Area
      </h2>
      <p className="mt-2 max-w-2xl text-xs leading-relaxed text-slate-500 sm:text-sm">
        Serving Temecula and nearby communities with trusted smog, diagnostics, and auto repair.
      </p>
      <ul className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-6">
        {SERVICE_AREA_CITIES.map((city) => (
          <li key={city}>
            <span
              className={cn(
                "flex min-h-[2.5rem] items-center justify-center rounded-xl px-3 py-2 text-center text-xs font-medium sm:text-sm",
                light
                  ? "border border-slate-200 bg-white text-slate-700 shadow-sm"
                  : "border border-white/12 bg-white/[0.04] text-slate-200",
              )}
            >
              {city}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
